import createReducer from "./createReducer";
import {Action, ActionType} from "../model";
import {PaymentLogProps, UpcomingPaymentListProps} from "../model/payment";

export const upcomingPayments = createReducer({}, {
    [ActionType.FETCH_UPCOMING_PAYMENTS](state: UpcomingPaymentListProps, action: Action<UpcomingPaymentListProps>) {
        return action.payload;
    },

    [ActionType.FLUSH_UPCOMING_PAYMENTS](state: Function, action: Action<void>) {
        return action.payload;
    }
});


export const paymentLogs = createReducer([], {
    [ActionType.FETCH_PAYMENT_LOGS](state: PaymentLogProps[], action: Action<PaymentLogProps>) {
        return action.payload;
    },

    [ActionType.FLUSH_PAYMENT_LOGS](state: Function, action: Action<void>) {
        return action.payload;
    }
});


